import axios from 'axios';

const onSubmit = async (orderDetails) => {
  try {
    await axios.post('https://pedir-prueba.p89nps.easypanel.host/orders', orderDetails);
    console.log('Detalles de la orden enviados correctamente');
    // Aquí podrías redirigir al usuario a una página de confirmación o mostrar un mensaje de éxito
  } catch (error) {
    console.error('Error al enviar los detalles de la orden:', error);
    // Aquí podrías mostrar un mensaje de error al usuario
  }
};

export default onSubmit;